export default "__VITE_ASSET__CzovJgJo__"